<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-curt-card">
    <v-row class="com-pc-card-header" v-show="pcPanelMode">
      <div class="com-pc-card-title">
        {{ text.title }} {{ tmDamList.curt.obsTime }}
      </div>
    </v-row>

    <template v-if="pcPanelMode">
      <v-row no-gutters>
        <v-col
          v-for="idx in tmDamList.curt.category.length"
          :key="idx"
          align="center"
          class="tm-pc-slider px-1 py-3"
          cols="6"
        >
          <p class="tm-pc-slider-category mb-0">{{ tmDamList.curt.category[idx - 1].title }}</p>
          <v-row no-gutters class="d-flex flex-column align-center">
            <v-col
              v-for="item in tmDamList.curt.category[idx - 1].master"
              :key="item.label"
              class="tm-pc-slider-item d-flex align-center flex-wrap"
            >
              <div
                class="tm-pc-slider-side-content tm-pc-slider-item__name"
                v-if="item.stgCcd == null && item.stgOvlvl == null"
              >
                {{ item.label }}
              </div>
              <div
                v-else-if="stgMode === '1' && dspFlg === 2"
                class="tm-pc-slider-side-content tm-pc-slider-item__name"
              >
                {{ item.labelList[0] }}
              </div>
              <div v-else class="tm-pc-slider-side-content tm-pc-slider-item__name">
                {{ item.labelList[stgMode] }}
              </div>
              <div
                v-if="item.stgCcd == null && item.stgOvlvl == null"
                class="tm-pc-slider-side-content tm-pc-slider-item__data"
              >
                {{ item.value }}&nbsp;
                <span v-html="item.unit"></span>
              </div>
              <div
                v-else-if="stgMode === '1' && dspFlg === 2"
                class="tm-pc-slider-side-content tm-pc-slider-item__data"
              >
                {{ item.value[0] }}&nbsp;
                <span v-html="item.unit"></span>
              </div>
              <div v-else class="tm-pc-slider-side-content tm-pc-slider-item__data">
                {{ item.value[stgMode] }}&nbsp;
                <span v-html="item.unit"></span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <div class="annotation-large">
        {{ text.annotation1 }}{{ text.annotation2 }}
      </div>
    </template>

    <template v-if="!pcPanelMode">
      <v-row class="com-pc-card-contents" no-gutters>
        <v-sheet class="tm-pc-slider tm-pc-no-shadow">
          <v-carousel
            light
            v-model="carouselIdx"
            :height="carouselIdx === 1 ? 180 : 140"
          >
            <v-carousel-item
              v-for="(obs, idx) in tmDamList.curt.category"
              :key="obs.title"
            >
              <v-sheet class="tm-pc-no-shadow">
                <v-row class="tm-pc-slider-side">
                  <v-col class="tm-pc-slider-side-title left">
                    <span>{{ prevTitle(idx) }}</span>
                  </v-col>
                  <v-col class="tm-pc-slider-side-title center font-weight-bold">
                    <span>{{ obs.title }}</span>
                  </v-col>
                  <v-col class="tm-pc-slider-side-title right">
                    <span>{{ nextTitle(idx) }}</span>
                  </v-col>
                </v-row>

                <v-row no-gutters class="tm-pc-slider-contents" align="center">
                  <v-sheet
                    outlined
                    v-for="item in obs.master"
                    :key="item.label"
                    class="tm-pc-slider-side-sub-item tm-pc-slider-content-dam-size"
                  >
                    <div
                      v-if="
                        item.stgCcd == null &&
                          item.stgOvlvl == null &&
                          item.bgColor == null
                      "
                    >
                      <div class="tm-pc-slider-side-content">
                        {{ item.label }}
                      </div>
                    </div>
                    <div
                      v-else-if="item.bgColor != null"
                    >
                      <div class="tm-pc-slider-side-content">
                        {{ item.label }}
                      </div>
                    </div>
                    <div
                      v-else-if="stgMode === '1' && dspFlg === 2"
                      class="tm-pc-slider-content-dam-stg-card"
                    >
                      {{ item.labelList[0] }}
                    </div>
                    <div
                      v-else
                      class="tm-pc-slider-content-dam-stg-card"
                    >
                      {{ item.labelList[stgMode] }}
                    </div>
                    <v-divider></v-divider>
                    <div
                      v-if="item.stgCcd == null && item.stgOvlvl == null"
                      class="pb-1 tm-pc-slider-side-content tm-pc-slider-side-sub-item__data"
                    >
                      {{ item.value }}&nbsp;
                      <span v-html="item.unit"></span>
                    </div>
                    <div
                      v-else-if="stgMode === '1' && dspFlg === 2"
                      class="pb-1 tm-pc-slider-side-content tm-pc-slider-side-sub-item__data"
                    >
                      {{ item.value[0] }}&nbsp;
                      <span v-html="item.unit"></span>
                    </div>
                    <div v-else class="pb-1 tm-pc-slider-side-content tm-pc-slider-side-sub-item__data">
                      {{ item.value[stgMode] }}&nbsp;
                      <span v-html="item.unit"></span>
                    </div>
                  </v-sheet>
                </v-row>
                <div v-if="idx === 1" class="text-center annotation-small">
                  {{ text.annotation1 }}<br />
                  {{ text.annotation2 }}
                </div>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-sheet>
      </v-row>
    </template>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]ダム 最新観測値カード
 * TmDamCurt.vue
 * @author ILUKE
 */

export default {
  name: "tm-dam-curt",
  data() {
    return {
      nextindex: 0,
      /** 文字列リソース */
      text: {
        title: "最新観測値",
        annotation1: "※「治水容量」などの表示に向けて、プログラムの",
        annotation2: "改修中のため、現在の貯水位を参考にして下さい",
      },
      dwFldColor: "normal",
    };
  },
  props: {
    carousel: { default: 0, type: Number },
  },
  created: function() {
    this.$store.commit("Telemeter/setLatestObsIdx", this.carousel);
  },
  computed: {
    carouselIdx: {
      get() {
        return this.$store.state.Telemeter.latestObsIdx;
      },
      set(val) {
        this.$store.commit("Telemeter/setLatestObsIdx", val);
      },
    },
    /**
     * ダム諸量情報 取得
     */
    tmDamList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    prevTitle: function() {
      return function(idx) {
        if (idx === 0) {
          idx = this.$store.state.Telemeter.selectedTm.curt.category.length - 1;
        } else {
          idx = idx - 1;
        }
        var prevTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return prevTitle;
      };
    },
    nextTitle: function() {
      return function(idx) {
        if (
          idx ===
          this.$store.state.Telemeter.selectedTm.curt.category.length - 1
        ) {
          idx = 0;
        } else {
          idx = idx + 1;
        }
        var nextTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return nextTitle;
      };
    },
    /* フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** 水位表示 */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**  表示フラグ*/
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmDamDetailInfo.dwDspFlg;
      },
    },
  },
  mounted() {
    /** 下流水位超過 着色 */
    const crntfld = this.tmDamList.curt.dwStg;
    this.dwFldColor = this.setFloodColor(
      crntfld.stgOvlvl,
      crntfld.stgCcd,
      crntfld.rsrvStg,
      crntfld.warnStg,
      crntfld.spclWarnStg,
      crntfld.dngStg
    );
  },
  methods: {
    /** 下流水位超過 着色 */
    setFloodColor(ovlvl, ccd, rsrvStg, warnStg, spclWarnStg, dngStg) {
      if (ovlvl === 90) {
        // 氾濫発生
        return "occurrence";
      } else if (
        // 基準水位未設定
        rsrvStg === null &&
        warnStg === null &&
        spclWarnStg === null &&
        dngStg === null
      ) {
        return "notset";
      } else if (ovlvl === 80 || ovlvl === 70) {
        // 氾濫危険水位超過
        return "danger";
      } else if (ovlvl === 60 || ovlvl === 50) {
        // 避難判断水位超過
        return "refuge";
      } else if (ovlvl === 40 || ovlvl === 30 || ovlvl === 20) {
        // 氾濫注意水位超過
        return "caution";
      } else if (ovlvl === 10) {
        // 水防団待機水位超過
        return "standbyed";
      } else if (ccd === 190 || ccd === 160) {
        // 欠測
        return "missing";
      } else if (ccd === 140) {
        // 閉局
        return "close";
      } else {
        // 平常
        return "normal";
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
